<template>
    <div v-if="mensagem" class="alerta">
        {{ props.mensagem }}
    </div>
</template>

<script setup>
const props = defineProps({
    mensagem: {type: String, required: true}})
</script>

<style scoped>
.alerta{
    background-color: #f9e5c8;
    color: #7a4a02;
    padding: 5px;
    border-radius: 5px;
    border: 2px solid #ba7f2c;
    font-weight: bold;
    font-size: large;
    text-align: center;
}
</style>